const GuidesModeration: React.FC = () => {
  return (
    <div className="featured-articles-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>{" "}
        &#10132;{" "}
        <a href="/guides" className="breadcrumb-link">
          Guides
        </a>{" "}
        &#10132; Moderation Policies
      </p>
      <h2 className="help-heading">Moderation Policies</h2>
      <div className="moderation-container">
        <h4 className="moderation-title">
          The <a href="https://ceo.ca">CEO.ca</a> Moderated Environment Guide
          for Users
        </h4>
        <p className="moderation-quote">
          In sports, the best referees are seen and not heard.
        </p>
        <div className="moderation-content">
          <p>
            At <a href="https://ceo.ca">CEO.ca</a> we strive for a similar idea.
            So while the presence of a moderated environment should always be
            felt by the users, the less actual moderation that we have to engage
            in is an important measure of the success of the platform.
          </p>
          <p>Overall, moderators help ensure all channels remain: </p>
          <ul>
            <li>Open to all users</li>
            <li>Respectful</li>
            <li>Valuable to all users</li>
          </ul>
          <p>
            It takes opinions from all sides to make a valuable channel and
            Moderators bring an independent and dispassionate perspective to
            issues on a channel when they arise. Moderator action only occurs
            when a user has contravened a
            &nbsp;
            <a href="https://new.ceo.ca/house-rules">House Rule</a>
            &nbsp;
            in a clear fashion. There is no value in creating an echo-chamber so
            the stance a user takes (bullish or bearish) should not matter when
            moderators make their decisions.
          </p>
          <p>Moderators must abide by the following principles:</p>
          <ul>
            <li>
              Moderators are not to share any personal information gleaned about
              a user with third parties ever.
            </li>
            <li>
              Community mods cannot accept any form or remuneration from any third party to moderate a user/channel.
            </li>
            <li>
              Moderators are not allowed to moderate any channel where they hold
              (or have held within 1 month) a financial position.
            </li>
            <li>
              Should a community mod take actions where a conflict of interest
              exists, moderator privileges will be revoked immediately and
              without notice.
            </li>
          </ul>
          <h3>House Rules:</h3>
          <p>A full list of CEO.CA house rules can be found <a href="https://new.ceo.ca/house-rules">here</a></p>
          <h3>Common questions:</h3>
          <i>Why aren’t the moderators issuing a penalty for my flag?</i>
          <p>
            Please ensure that a post is a clear violation of our guidelines before flagging it, as the majority (likely around 90%) of flags submitted by users do not actually violate our guidelines.
          </p>
          <i>
            Why was I penalized for doing X while another user did something similar and was not penalized?
          </i>
          <p>This could be due to a few reasons:</p>
          <ol>
            <li>
              Moderators may consider a user's past behavior to determine if a pattern of violation exists.
            </li>
            <li>
              Moderation typically occurs only when a flag is raised, so it's possible that the other post went unnoticed.
            </li>
            <li>
              Moderation involves assessing the intent behind a post, so even though two posts may seem alike, their intent may be viewed differently by a moderator.
            </li>
          </ol>
          <i>
            User X is disrupting the channel and is only posting negative comments. Why won’t you ban that user?
          </i>
          <p>
            Moderators may ban users from channels if excessive disruption occurs. However, we value diverse opinions and only take this step in cases where the poster repeatedly violates our guidelines. 
            Posting negative comments about a stock is not a violation of our guidelines, so moderators will not take action against users simply because others in the channel hold different views.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GuidesModeration;
